import styles from './HomeSection.module.css'
import { Button, Col, Row } from "react-bootstrap";

export default function HomeSection() {
    return (
         <Row className={`${styles.container} mt-5 mb-5 align-items-start m-auto p-0`}>
            <Col xs="8" sm="8" md="8" lg="8" className={ `m-auto`}>
                <Button className={styles.button} variant="outline-light" onClick={() => {
                    window.location.href = "https://mono-group.com/en/"
                }}>Home</Button>
                 
            </Col>
            <Col xs="1" sm="1" md="1" lg="1" className={styles.langSwitchContainer}>
                <span className={styles.langSwitchText}>
                    <a onClick={() => { window.location.href = "https://mono-group.com/monoracing" }}>
                        <b>ENG</b>
                    </a>&nbsp; / 
                    <a onClick={() => { window.location.href = "https://mono-group.com/monoracing-hu" }}>
                    &nbsp;&nbsp;HUN
                    </a>
                </span>
            </Col>
        </Row>
    )
}